import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {SshMessage} from '../models/ssh-message';
import {SSH_MESSAGE_TYPES, SSH_WORKER_CMD} from '../models/enums';
import {workerUrl} from '../workers/terminal.worker';

@Injectable()
export class SshService {
    private readonly worker: Worker = null;
    public messages: Subject<any> = new Subject<any>();

    constructor() {
        const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
        const url = `${protocol}://${location.hostname}:${location.port}/terminal/`;

        this.worker = new Worker(workerUrl);
        this.worker.addEventListener('message', ($event: MessageEvent) => {
            const {cmd, data} = $event.data as any;

            if (cmd === SSH_WORKER_CMD.MESSAGE) {
                this.messages.next(data);
            }
        });

        this.worker.postMessage({cmd: SSH_WORKER_CMD.CONNECT, url});
    }

    writeMsg(msg) {
        this.worker.postMessage({cmd: SSH_WORKER_CMD.MESSAGE, msg});
    }

    open() {
        const msgObj = new SshMessage(SSH_MESSAGE_TYPES.OPEN);
        this.writeMsg(msgObj.toJson());
    }

    connect(data) {
        const msg = new SshMessage(SSH_MESSAGE_TYPES.CONNECT, data);
        this.writeMsg(msg.toJson());
    }

    read(channel) {
        const msg = new SshMessage(SSH_MESSAGE_TYPES.READ, channel);
        this.writeMsg(msg.toJson());
    }

    // tslint:disable-next-line:variable-name
    write(channel_id, msg) {
        const msgObj = new SshMessage(SSH_MESSAGE_TYPES.WRITE, {channel_id, msg});
        this.writeMsg(msgObj.toJson());
    }

    // tslint:disable-next-line:variable-name
    resize(channel_id, width, height) {
        const msgObj = new SshMessage(SSH_MESSAGE_TYPES.RESIZE, {channel_id, width, height});
        this.writeMsg(msgObj.toJson());
    }

    close(channel) {
        const msgObj = new SshMessage(SSH_MESSAGE_TYPES.CLOSE, channel);
        this.writeMsg(msgObj.toJson());
    }

    disconnect() {
        const msgObj = new SshMessage(SSH_MESSAGE_TYPES.DISCONNECT);
        this.writeMsg(msgObj.toJson());
    }

    closeWS() {
        this.worker.terminate();
    }

}
